








































































































































































































































































































































































































































































































































































































































































































import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import BackofficeGlobalStore from '@/components/Backoffice/Store/BackofficeGlobalStore'
import { maskDateTime, maskMoney } from '@/utils/common'
import { TipoDocumentoUpload } from '@/types/_'
import { SolicitacaoResumoResponse } from '@/types/interfaces/Solicitacao'
import { autorizacaoMateriaisTemplate } from '@/template/pdf/autorizacao-materiais/autorizacao-materiais-pdf'
import { StatusDoProtocoloEnum } from '@/types/interfaces/protocolo/status-do-protocolo.enum'

// Guia TISS Internação
// Guia TISS OPME

@Component

export default class ComponentBackofficeAnexo extends Vue {
  @Prop({ required: true }) tipoAutorizacaoAnexo: any

  roboFinxName = 'Robô Fin-X'

  get getBackofficeGlobalStore() {
    return getModule(BackofficeGlobalStore, this.$store)
  }

  get getTemplate() {
    return this.getBackofficeGlobalStore.template.formulario
  }

  titulo(field: string, defaultValue: string) {
    if (this.getTemplate && this.getTemplate[field]) {
      const campo = this.getTemplate[field]
      return (campo && campo.titulo) || defaultValue
    }

    return defaultValue
  }

  get noDocumentAvailable() {
    return this.getBackofficeGlobalStore.solicitacao.laudos.length === 0
      && (this.getBackofficeGlobalStore.solicitacao.resumos && this.getBackofficeGlobalStore.solicitacao.resumos.length === 0)
      && !this.canShowPedidoMedico
  }

  get getOrcamentoDeCirurgiaParticularAvulso() {
    const anexos: any[] = []
    if (this.getBackofficeGlobalStore.solicitacao.laudos) {
      const d = this.getBackofficeGlobalStore.solicitacao.laudos.filter(c => c.tipoDocumento === TipoDocumentoUpload.OrcamentoDeCirurgiaParticular)
      d.map((a) => {
        anexos.push({ url: a.url, nomeOriginalArquivo: a.nomeOriginalArquivo })
        return a
      })
    }
    return anexos
  }

  get getPedidoMedico() {
    const anexos: any[] = []
    const { url, urlNaoParticular, resumos } = this.getBackofficeGlobalStore.solicitacao
    const temPedidoMedico = url != null && url.length > 0
    const temPedidoMedicoNaoParticular = urlNaoParticular != null && urlNaoParticular.length > 0

    const adicionarAnexo = (anexoUrl: string, nomeOriginalArquivo: string, createdOn?: string) => {
      const anexo: any = {
        url: anexoUrl,
        nomeOriginalArquivo,
        createdByName: this.roboFinxName,
      }
      if (createdOn) {
        anexo.createdOn = createdOn
      }
      anexos.push(anexo)
    }

    if (temPedidoMedico || temPedidoMedicoNaoParticular) {
      if (resumos) {
        const resumosFiltrados = resumos.filter((c: SolicitacaoResumoResponse) => c.tipoDocumento.includes(TipoDocumentoUpload.PedidoMedico))
        if (resumosFiltrados.length > 0) {
          resumosFiltrados.forEach((a) => {
            if (temPedidoMedico && url) {
              adicionarAnexo(url, 'Pedido médico', a.createdOn)
            }
            if (temPedidoMedicoNaoParticular && urlNaoParticular) {
              adicionarAnexo(urlNaoParticular, 'Pedido médico não particular', a.createdOn)
            }
          })
        } else {
          if (temPedidoMedico && url) {
            adicionarAnexo(url, 'Pedido médico')
          }
          if (temPedidoMedicoNaoParticular && urlNaoParticular) {
            adicionarAnexo(urlNaoParticular, 'Pedido médico não particular')
          }
        }
      } else {
        if (temPedidoMedico && url) {
          adicionarAnexo(url, 'Pedido médico')
        }
        if (temPedidoMedicoNaoParticular && urlNaoParticular) {
          adicionarAnexo(urlNaoParticular, 'Pedido médico não particular')
        }
      }
    }
    return anexos
  }

  get getAnexoOperadora() {
    const anexos: any[] = []
    if (this.getBackofficeGlobalStore.solicitacao.laudos) {
      const d = this.getBackofficeGlobalStore.solicitacao.laudos.filter(c => c.tipoDocumento === TipoDocumentoUpload.AnexoOperadora)
      d.map((a) => {
        anexos.push({ url: a.url, nomeOriginalArquivo: a.nomeOriginalArquivo, createdByName: a.createdByName, createdOn: a.createdOn })
        return a
      })
    }
    return anexos
  }

  get getCotacaoOpme() {
    const anexos: any[] = []
    if (this.getBackofficeGlobalStore.solicitacao.laudos) {
      const d = this.getBackofficeGlobalStore.solicitacao.laudos.filter(c => c.tipoDocumento === TipoDocumentoUpload.CotacaoOpme)
      d.map((a) => {
        anexos.push({ url: a.url, nomeOriginalArquivo: a.nomeOriginalArquivo, createdByName: a.createdByName, createdOn: a.createdOn })
        return a
      })
    }
    return anexos
  }

  get getRespostaOperadora() {
    const anexos: any[] = []
    if (this.getBackofficeGlobalStore.solicitacao.laudos) {
      const d = this.getBackofficeGlobalStore.solicitacao.laudos.filter(c => c.tipoDocumento === TipoDocumentoUpload.GuiaAutorizacaoDoRoboAutorizacao)
      d.map((a) => {
        anexos.push({ url: a.url, nomeOriginalArquivo: a.nomeOriginalArquivo, createdByName: a.createdByName, createdOn: a.createdOn })
        return a
      })
    }
    return anexos
  }

  get getLaudos() {
    const anexos: any[] = []
    if (this.getBackofficeGlobalStore.solicitacao.laudos) {
      const d = this.getBackofficeGlobalStore.solicitacao.laudos.filter(c => c.tipoDocumento === TipoDocumentoUpload.Laudo)
      d.map((a) => {
        anexos.push({ url: a.url, nomeOriginalArquivo: a.nomeOriginalArquivo, createdByName: a.createdByName, createdOn: a.createdOn })
        return a
      })
    }
    return anexos
  }

  get getDocumentacaoPaciente() {
    const anexos: any[] = []
    if (this.getBackofficeGlobalStore.solicitacao.laudos) {
      const d = this.getBackofficeGlobalStore.solicitacao.laudos.filter(c => c.tipoDocumento === TipoDocumentoUpload.DocumentacaoPaciente)
      d.map((a) => {
        anexos.push({ url: a.url, nomeOriginalArquivo: a.nomeOriginalArquivo, createdByName: a.createdByName, createdOn: a.createdOn })
        return a
      })
    }
    return anexos
  }

  get getDocumentosDiversos() {
    const anexos: any[] = []
    if (this.getBackofficeGlobalStore.solicitacao.laudos) {
      const d = this.getBackofficeGlobalStore.solicitacao.laudos.filter(c => c.tipoDocumento === TipoDocumentoUpload.DocumentosDiversos)
      d.map((a) => {
        anexos.push({ url: a.url, nomeOriginalArquivo: a.nomeOriginalArquivo, createdByName: a.createdByName, createdOn: a.createdOn })
        return a
      })
    }
    return anexos
  }

  get getTermoDeConsentimento() {
    const anexos: any[] = []
    if (this.getBackofficeGlobalStore.solicitacao.laudos) {
      const d = this.getBackofficeGlobalStore.solicitacao.laudos.filter(c => c.tipoDocumento === TipoDocumentoUpload.TermoDeConsentimento)
      d.map((a) => {
        anexos.push({ url: a.url, nomeOriginalArquivo: a.nomeOriginalArquivo, createdByName: a.createdByName, createdOn: a.createdOn })
        return a
      })
    }
    return anexos
  }

  get getRequisicaoCotacao() {
    const anexos: any[] = []
    if (this.getBackofficeGlobalStore.solicitacao.laudos) {
      const d = this.getBackofficeGlobalStore.solicitacao.laudos.filter(c => c.tipoDocumento === TipoDocumentoUpload.RequisicaoCotacao)
      d.map((a) => {
        anexos.push({ url: a.url, nomeOriginalArquivo: a.nomeOriginalArquivo, createdByName: a.createdByName, createdOn: a.createdOn })
        return a
      })
    }
    return anexos
  }

  get getPedidoMedicoSemAssinatura() {
    const anexos: any[] = []
    if (this.getBackofficeGlobalStore.solicitacao.laudos) {
      const d = this.getBackofficeGlobalStore.solicitacao.laudos.filter(c => c.tipoDocumento === TipoDocumentoUpload.PedidoMedicoSemAssinatura)
      d.map((a) => {
        anexos.push({ url: a.url, nomeOriginalArquivo: a.nomeOriginalArquivo, createdByName: a.createdByName, createdOn: a.createdOn })
        return a
      })
    }
    return anexos
  }

  get getOrcamentoAprovado() {
    const anexos: any[] = []
    if (this.getBackofficeGlobalStore.solicitacao.laudos) {
      const d = this.getBackofficeGlobalStore.solicitacao.laudos.filter(c => c.tipoDocumento === TipoDocumentoUpload.OrcamentoDeCirurgiaParticularAprovado)
      d.map((a) => {
        anexos.push({ url: a.url, nomeOriginalArquivo: a.nomeOriginalArquivo, createdByName: a.createdByName, createdOn: a.createdOn })
        return a
      })
    }
    return anexos
  }

  get getGuiaTissInternacao() {
    const anexos: any[] = []
    if (this.getBackofficeGlobalStore.solicitacao.laudos) {
      const d = this.getBackofficeGlobalStore.solicitacao.laudos.filter(c => c.tipoDocumento === TipoDocumentoUpload.GuiaTissInternacao)
      d.map((a) => {
        anexos.push({ url: a.url, nomeOriginalArquivo: a.nomeOriginalArquivo, createdByName: a.createdByName, createdOn: a.createdOn })
        return a
      })
    }
    return anexos
  }

  get getGuiaTissOpme() {
    const anexos: any[] = []
    if (this.getBackofficeGlobalStore.solicitacao.laudos) {
      const d = this.getBackofficeGlobalStore.solicitacao.laudos.filter(c => c.tipoDocumento === TipoDocumentoUpload.GuiaTissOpme)
      d.map((a) => {
        anexos.push({ url: a.url, nomeOriginalArquivo: a.nomeOriginalArquivo, createdByName: a.createdByName, createdOn: a.createdOn })
        return a
      })
    }
    return anexos
  }

  get getLaudoAnestesista() {
    const anexos: any[] = []
    if (this.getBackofficeGlobalStore.solicitacao.laudos) {
      const d = this.getBackofficeGlobalStore.solicitacao.laudos.filter(c => c.tipoDocumento === TipoDocumentoUpload.LaudoAnestesista)
      d.map((a) => {
        anexos.push({ url: a.url, nomeOriginalArquivo: a.nomeOriginalArquivo, createdByName: a.createdByName, createdOn: a.createdOn })
        return a
      })
    }
    return anexos
  }

  get getSolicitacaoReservaDeSangue() {
    const anexos: any[] = []
    if (this.getBackofficeGlobalStore.solicitacao.laudos) {
      const d = this.getBackofficeGlobalStore.solicitacao.laudos.filter(c => c.tipoDocumento === TipoDocumentoUpload.SolicitacaoReservaDeSangue)
      d.map((a) => {
        anexos.push({ url: a.url, nomeOriginalArquivo: a.nomeOriginalArquivo, createdByName: a.createdByName, createdOn: a.createdOn })
        return a
      })
    }
    return anexos
  }

  get getResumo() {
    const anexos: any[] = []
    if (this.getBackofficeGlobalStore.solicitacao.resumos) {
      this.getBackofficeGlobalStore.solicitacao.resumos.map((a) => {
        anexos.push({
          id: a.id,
          url: a.url || '',
          errorMessage: !a.url ? 'Houve uma falha ao criar este resumo ou, ele ainda não foi processado...' : '',
          nomeOriginalArquivo: a.nome || `${a.tipoDocumento ? a.tipoDocumento.toLocaleUpperCase() : ''}`,
          createdByName: this.roboFinxName,
          createdOn: a.createdOn,
        })
        return a
      })
    }
    return anexos
  }

  get canShowPedidoMedico() {
    return this.getPedidoMedico
    && this.getPedidoMedico.length > 0
    && this.tipoAutorizacaoAnexo.pedidoMedico
    && !this.getBackofficeGlobalStore.solicitacao.criadaComoOrcamentoParticularAvulso
  }

  get checklistDocumentosObrigatorios() {
    return this.getBackofficeGlobalStore.solicitacao.checklistDocumentosObrigatorios
  }

  get doctorProtocolReasonFiles(): { name: string, url: string }[] | undefined {
    const surgerySolicitationData = this.getBackofficeGlobalStore.solicitacao
    let surgeryProtocolFilesData = surgerySolicitationData.laudos

    surgeryProtocolFilesData = surgeryProtocolFilesData.filter(fileData => fileData.tipoDocumento === 'JustificativaMedicoNaoSegueOProtocolo')

    return surgeryProtocolFilesData.map(file => ({
      name: file.nomeOriginalArquivo,
      url: file.url,
    }))
  }

  get canShowGuiaDeAutorizacaoDeMateriais() {
    return this.getBackofficeGlobalStore.segueOProtocoloStatus === StatusDoProtocoloEnum.segueOProtocolo
    && this.getBackofficeGlobalStore.solicitacao.etapa.key === 'Autorizacao'
  }

  async generateGuiaDeAutorizacaoDeMateriais() {
    await autorizacaoMateriaisTemplate.generate(this.getBackofficeGlobalStore.solicitacao)
  }

  maskDateTime(value: string) {
    return maskDateTime(value)
  }

  maskMoneyUtil(value: string) {
    return maskMoney(value)
  }

  get canShowBudgetValue() {
    return this.getBackofficeGlobalStore.solicitacao.hospital
      && this.getBackofficeGlobalStore.solicitacao.hospital.hospitalFazOrcamentoAntesDoAgendamento
      && this.getBackofficeGlobalStore.solicitacao
      && this.getBackofficeGlobalStore.solicitacao.valorOrcamentoParticular
      && this.getBackofficeGlobalStore.solicitacao.valorOrcamentoParticular > 0
  }
}
